import { render } from "./AddWidget.vue?vue&type=template&id=8d39abf4&scoped=true"
import script from "./AddWidget.vue?vue&type=script&lang=js"
export * from "./AddWidget.vue?vue&type=script&lang=js"

import "./AddWidget.vue?vue&type=style&index=0&id=8d39abf4&scoped=true&lang=css"
import "./AddWidget.vue?vue&type=style&index=1&id=8d39abf4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d39abf4"]])

export default __exports__